<script setup lang="ts">
import { AuthRegisterForm } from '@/modules/auth/components';
definePageMeta({
  layout: 'default',
  auth: {
    unauthenticatedOnly: true,
    navigateAuthenticatedTo: '/',
  },
});

useHead({
  title: 'Register',
});
</script>
<template>
  <v-container class="d-flex mx-auto align-items-center fill-height register-container">
    <AuthRegisterForm data-testid="register-form" />
  </v-container>
</template>

<style lang="scss" scoped>
@media (max-width: 768px) {
  .register-container {
    display: block !important;
    padding-top: 48px;
  }
}
</style>
